import React from "react";
import { Box, Typography } from "@material-ui/core";

interface IMenuItemLabelProps {
  icon: React.ElementType;
  label: string;
}

export const MenuItemLabel = ({ icon: Icon, label }: IMenuItemLabelProps) => {
  return (
    <Box component="span" display="flex" alignItems="center">
      <Icon style={{ fontSize: "18" }} />
      <Box component="span" ml={1} />
      <Typography variant="button" component="span" align="center">
        {label}
      </Typography>
    </Box>
  );
};
